import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { bell_medium} from '@dnb/eufemia/icons';
import { navigate } from 'gatsby';
import {MenuButton} from '@dnb/header';

// TODO: Replace this with real implementation when notifications service is ready
const getNotificationsNumber = () => 6;

const InboxButton = () => {
  const intl = useIntl();
  const notifications = getNotificationsNumber();
  const notificationsButtonAriaLabel = intl.formatMessage(
    { id: 'dnb_header_activity_notifications_alt_text' },
    { numNotifications: notifications }
  );
  return (
      <MenuButton
        text={<FormattedMessage id="dnb_header_activity_button" />}
        icon={bell_medium}
        aria-label={notificationsButtonAriaLabel}
        badge={notifications}
        on_click={() => navigate('/')}
        disabled // TODO: Enable once notifications and authentication are implemented
      />
  );
};

export default InboxButton;
